
import React, { useState, useEffect } from 'react';
import './App.css';
import Shell from './components/Shell/Shell';
import { AppStateContext, defaultAppState } from './context/AppStateContext';

function App() {
  const [appState, setAppState] = useState(defaultAppState);

  return (
    <AppStateContext.Provider value={{ appState, setAppState }}>
      <Shell />
    </AppStateContext.Provider>
  );
}

export default App;
